import { render } from "./complete-court.vue?vue&type=template&id=3c119f62"
import script from "./complete-court.vue?vue&type=script&lang=js"
export * from "./complete-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__